import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import firebase from "firebase/app";
import { FirestoreService } from 'src/app/service/firestore.service';
import { RemoteRtcComponent } from './remoteRTC/remotertc.compenent';
//import { Observable } from 'rxjs';
declare let RTCPeerConnection: any;

@Component({
  selector: 'app-meeting',
  templateUrl: './meeting.component.html',
  styleUrls: ['./meeting.component.css']
})
// @ts-ignore
export class MeetingComponent implements OnInit {
  callActive: boolean = false;
  pc: any = null;
  localStream: any;
  // @ts-ignore
  channel: AngularFireList<{}> ;
  // @ts-ignore
  database: firebase.database.Reference;
  senderId: string = '';

  // @ts-ignore
  @ViewChild("me", {static: true}) me: any;
  // @ts-ignore
  @ViewChild("remote", {static: true}) remote: any;

  @ViewChildren("remotes", {read: true}) remotes: QueryList<RemoteRtcComponent>;

  views:any[] = new Array<any>();

  constructor(
    private afDb: AngularFireDatabase,
    public fserv: FirestoreService
  ) { }

  ngOnInit() {
    this.setupWebRtc();
  }

  public ngOnDestroy() {
    this.pc.close();
    let tracks = this.localStream.getTracks();
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].stop();
    }
    this.callActive = false;
  }

  setupWebRtc() {
    this.senderId = this.guid();
    let channelName = "/webrtctest";
    this.channel = this.afDb.list(channelName);
    this.database = this.afDb.database.ref(channelName);
    this.database.on("child_added", this.readMessage.bind(this));

    try {
      this.pc = new RTCPeerConnection({
        iceServers: [
          { urls: "stun:stun.services.mozilla.com" },
          { urls: "stun:stun.l.google.com:19302" }
        ]
      }, { optional: [] });
    } catch (error) {
      console.log(error);
      this.pc = new RTCPeerConnection({
        iceServers: [
          { urls: "stun:stun.services.mozilla.com" },
          { urls: "stun:stun.l.google.com:19302" }
        ]
      }, { optional: [] });
    }


    this.pc.onicecandidate = (event:any) => {
      event.candidate ? this.sendMessage(this.senderId, JSON.stringify({ ice: event.candidate })) : console.log("Sent All Ice");
    }

    this.pc.onremovestream = (event:any) => {
      console.log('Stream Ended');
    }

    this.pc.ontrack = (event:any) =>
      (this.remote.nativeElement.srcObject = event.streams[0]); // use ontrack
      this.showMe();
    }

  sendMessage(senderId: string, data: any) {
    var msg = this.channel.push({ sender: senderId, message: data });
    msg.remove();
  }

  readMessage(data: any) {
    if (!data) return;
    try {
      var msg = JSON.parse(data.val().message);
      let personalData = data.val().personalData;
      var sender = data.val().sender;
      if (sender != this.senderId) {
        if (msg.ice != undefined && this.pc != null) {
          this.pc.addIceCandidate(new RTCIceCandidate(msg.ice));
        } else if (msg.sdp.type == "offer") {
          this.callActive = true;
          this.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp))
            .then(() => this.pc.createAnswer())
            .then((answer:string) => this.pc.setLocalDescription(answer))
            .then(() => this.sendMessage(this.senderId, JSON.stringify({ sdp: this.pc.localDescription })));
        } else if (msg.sdp.type == "answer") {
          this.callActive = true;
          this.pc.setRemoteDescription(new RTCSessionDescription(msg.sdp));
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  /*draw(canvas, img, self) {
    canvas.getContext('2d').drawImage(img,0,0,500,300);
    canvas.getContext('2d').fillRect(Math.random() * 500-5, Math.random() * 300-5, 10, 10);
    //requestAnimationFrame(function() { self.draw(canvas, img, self); });
  }*/
  showVideoAsset(stream, vstream) {
    console.log(stream);
          console.log(vstream);
          //vstream.addTrack(stream.getAudioTracks()[0]);
          stream.addTrack(vstream.getVideoTracks()[0]);
          this.me.nativeElement.srcObject = stream;
          console.log(stream);
        //})
        //.then( stream => {
        //  console.log(stream);
          this.pc.addStream( stream );
          this.localStream = stream;

  }

  showMe() {
    let self = this;
    navigator.mediaDevices.getUserMedia({ audio: false, video: true })
      .then(stream => (this.me.nativeElement.srcObject = stream))
      .then(stream => {
        this.pc.addStream(stream);
        this.localStream = stream;
      })
      .catch(function(err) {
        const video = document.createElement('video');
        video.width = 500; video.height = 300;
        video.loop = true;
        video.src = '/assets/rostedCoffee.mp4';

        video.onplay = function() {
        // @ts-ignore
          let vstream = video.captureStream();
          navigator.mediaDevices.getUserMedia({ audio: true, video: false })
            .then(stream => {
              self.showVideoAsset(stream, vstream);
          })
          .catch(function(err) { console.error(err); });
        };
        video.autoplay = true;
        //console.log("An error occurred: " + err);
        /*const canvas = document.createElement('canvas');
        canvas.width=500; canvas.height=300;
        const img = new Image();
        //img.crossOrigin = 'anonymous';
        //img.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAJF0lEQVR4Xu3WMa6WVRhFYYg3EGMhBRaS2FE5VUbDSBwChTGh0A7RUJlYWHtIuFns81Af+Pe71pcVnr55/fbvJ/4ggMCVBJ4KwJXeHY3AvwQEwIeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEBOBi+U5HQAB8AwhcTEAALpbvdAQEwDeAwMUEpgLw8o8/3z18evLhYp9O/8IEPj17eP7+hxevvvDPPNo/PxWAH3/7+Muzv775/dHo+aHrCHz89uG7X3/6/ueVwwVgxaQ7HoWAADwK5s/7Ef8D+Dxu/tb/JyAA/5/Vo78UgEdHft0PCkBYuQCE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERQpAWM7INAEIixSAsJyRaQIQFikAYTkj0wQgLFIAwnJGpglAWKQAhOWMTBOAsEgBCMsZmSYAYZECEJYzMk0AwiIFICxnZJoAhEUKQFjOyDQBCIsUgLCckWkCEBYpAGE5I9MEICxSAMJyRqYJQFikAITljEwTgLBIAQjLGZkmAGGRAhCWMzJNAMIiBSAsZ2SaAIRFCkBYzsg0AQiLFICwnJFpAhAWKQBhOSPTBCAsUgDCckamCUBYpACE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERQpAWM7INAEIixSAsJyRaQIQFikAYTkj0wQgLFIAwnJGpglAWKQAhOWMTBOAsEgBCMsZmSYAYZECEJYzMk0AwiIFICxnZJoAhEUKQFjOyDQBCIsUgLCckWkCEBYpAGE5I9MEICxSAMJyRqYJQFikAITljEwTgLBIAQjLGZkmAGGRAhCWMzJNAMIiBSAsZ2SaAIRFCkBYzsg0AQiLFICwnJFpAhAWKQBhOSPTBCAsUgDCckamCUBYpACE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERQpAWM7INAEIixSAsJyRaQIQFikAYTkj0wQgLFIAwnJGpglAWKQAhOWMTBOAsEgBCMsZmSYAYZECEJYzMk0AwiIFICxnZJoAhEUKQFjOyDQBCIsUgLCckWkCEBYpAGE5I9MEICxSAMJyRqYJQFikAITljEwTgLBIAQjLGZkmAGGRAhCWMzJNAMIiBSAsZ2SaAIRFCkBYzsg0AQiLFICwnJFpAhAWKQBhOSPTBCAsUgDCckamCUBYpACE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERQpAWM7INAEIixSAsJyRaQIQFikAYTkj0wQgLFIAwnJGpglAWKQAhOWMTBOAsEgBCMsZmSYAYZECEJYzMk0AwiIFICxnZJoAhEUKQFjOyDQBCIsUgLCckWkCEBYpAGE5I9MEICxSAMJyRqYJQFikAITljEwTgLBIAQjLGZkmAGGRAhCWMzJNAMIiBSAsZ2SaAIRFCkBYzsg0AQiLFICwnJFpAhAWKQBhOSPTBCAsUgDCckamCUBYpACE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERQpAWM7INAEIixSAsJyRaQIQFikAYTkj0wQgLFIAwnJGpglAWKQAhOWMTBOAsEgBCMsZmSYAYZECEJYzMk0AwiIFICxnZJoAhEUKQFjOyDQBCIsUgLCckWkCEBYpAGE5I9MEICxSAMJyRqYJQFikAITljEwTgLBIAQjLGZkmAGGRAhCWMzJNAMIiBSAsZ2SaAIRFCkBYzsg0AQiLFICwnJFpAhAWKQBhOSPTBCAsUgDCckamCUBYpACE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERQpAWM7INAEIixSAsJyRaQIQFikAYTkj0wQgLFIAwnJGpglAWKQAhOWMTBOAsEgBCMsZmSYAYZECEJYzMk0AwiIFICxnZJoAhEUKQFjOyDQBCIsUgLCckWkCEBYpAGE5I9MEICxSAMJyRqYJQFikAITljEwTgLBIAQjLGZkmAGGRAhCWMzJNAMIiBSAsZ2SaAIRFCkBYzsg0AQiLFICwnJFpAhAWKQBhOSPTBCAsUgDCckamCUBYpACE5YxME4CwSAEIyxmZJgBhkQIQljMyTQDCIgUgLGdkmgCERb784893D5+efAhPNO0rJ/Dp2cPz9z+8ePWVn/Hf/KdvXr/9e+UYdyCAwBkBATjj5TUCUwQEYEqnYxA4IyAAZ7y8RmCKgABM6XQMAmcEBOCMl9cITBEQgCmdjkHgjIAAnPHyGoEpAgIwpdMxCJwREIAzXl4jMEVAAKZ0OgaBMwICcMbLawSmCAjAlE7HIHBGQADOeHmNwBQBAZjS6RgEzggIwBkvrxGYIiAAUzodg8AZAQE44+U1AlMEBGBKp2MQOCMgAGe8vEZgioAATOl0DAJnBATgjJfXCEwREIApnY5B4IyAAJzx8hqBKQICMKXTMQicERCAM15eIzBFQACmdDoGgTMCAnDGy2sEpggIwJROxyBwRkAAznh5jcAUAQGY0ukYBM4ICMAZL68RmCIgAFM6HYPAGQEBOOPlNQJTBARgSqdjEDgjIABnvLxGYIqAAEzpdAwCZwQE4IyX1whMERCAKZ2OQeCMgACc8fIagSkCAjCl0zEInBEQgDNeXiMwRUAApnQ6BoEzAgJwxstrBKYICMCUTscgcEZAAM54eY3AFAEBmNLpGATOCAjAGS+vEZgiIABTOh2DwBkBATjj5TUCUwQEYEqnYxA4I/APr16JXayeM0AAAAAASUVORK5CYII=';
        img.src = '/assets/profile.jpg';

        img.onload = function() {
          //self.draw(canvas, img, self);
          //const colors = ['#999','#f00','#ff0','#09#','#0ff','#00f','#f0f','#9f0'];
          //let c1 = colors[Math.floor(Math.random() * colors.length)];
          //setInterval(() => {self.draw(canvas, img, self)}, 40);
          //canvas.getContext('2d').drawImage(img,0,0,500,300);
          setInterval(() => {
            canvas.getContext('2d').drawImage(img,0,0,500,300);
            canvas.getContext('2d').fillRect(Math.random() * 500-5, Math.random() * 300-5, 10, 10);
          }, 25);
          // @ts-ignore
          let _stream = canvas.captureStream(25);
          self.me.nativeElement.srcObject = _stream;*/

          //video.play();
        //};
      }).catch(function(err) {console.log(err);});
  }

  showRemote() {
    try {
      this.pc.createOffer()
        .then((offer:any) => this.pc.setLocalDescription(offer))
        .then(() => {
          this.sendMessage(this.senderId, JSON.stringify({ sdp: this.pc.localDescription }));
          this.callActive = true;
        });
    } catch (error) {
      this.setupWebRtc();
      console.log(error);
    }
  }

  hangup() {
    this.pc.close();
    let tracks = this.localStream.getTracks();
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].stop();
    }
    this.callActive = false;
    location.href = location.href;
  }

  guid() {
    return this.fserv.user.email;
    //return (this.s4() + this.s4() + "-" + this.s4() + "-" + this.s4() + "-" + this.s4() + "-" + this.s4() + this.s4() + this.s4());
  }
  s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }

  ngAfterViewInit(){
    // print array of CustomComponent objects
    console.log(this.remotes.toArray());
}

}
